module.exports = __webpack_public_path__ + "static/img/cable_256.5c61ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cable_256.png
// module id = k3+z
// module chunks = 0